module.exports = __webpack_public_path__ + "static/media/coloured-card.6e165911.jpg";